import React, { useEffect } from "react";
import { useData } from "./dataContext";

import { useLocation } from "react-router";

const DataFetcher = () => {
  const { data, setData } = useData();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get the current URL
        const currentUrl = window.location.search;

        const urlParams = new URLSearchParams(currentUrl);
        const jsonUrl = urlParams.get("data");

        // Check if data is already cached
        const cachedData = localStorage.getItem(jsonUrl);
        if (cachedData) {
          setData(JSON.parse(cachedData));
        }

        // Fetch the JSON data
        const response = await fetch(jsonUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const fetchedData = await response.json();

        // Save data to context and localStorage
        setData(fetchedData);
        localStorage.setItem(jsonUrl, JSON.stringify(fetchedData));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const pingBackend = async () => {
      try {
        // Get the current URL
        const currentUrl = window.location.search;

        const urlParams = new URLSearchParams(currentUrl);
        const jsonUrl = urlParams.get("data");
        const touchUrl = jsonUrl + ".ping";

        // Fetch the JSON data
        const response = await fetch(touchUrl, { method: "POST" });
        if (!response.ok) {
          throw new Error("Failed to ping backend");
        }
      } catch (error) {
        console.error("Error pinging backend:", error);
      }
    };

    if (!data) {
      fetchData();
      pingBackend();
    }
  }, [location.pathname, data, setData]);

  return null; // This component doesn't render anything
};

export default DataFetcher;
